// Módulo principal del formulario con funciones comunes
class FormularioCore {
  constructor() {
    this.paso1Data = {};
    this.imagenProductoBase64 = '';
    this.imagenBoletaBase64 = '';
    this.imagenShopifyUrl = '';
  }

  // Utilidades
  obtenerValorCampo(id) {
    const elemento = document.getElementById(id);
    if (!elemento) {
      console.error(`No se encontró el elemento con ID: ${id}`);
      return '';
    }
    return elemento.value ? elemento.value.trim() : '';
  }

  formatearRut(rut) {
    let rutLimpio = rut.replace(/\./g, '').replace(/\s/g, '');
    
    if (!rutLimpio.includes('-')) {
      if (rutLimpio.length > 1) {
        rutLimpio = rutLimpio.slice(0, -1) + '-' + rutLimpio.slice(-1);
      }
    }
    
    return rutLimpio;
  }

  determinarGarantia(fechaCompra) {
    if (!fechaCompra) return "Sin Garantía";
    
    const fechaCompraDate = new Date(fechaCompra);
    const fechaActual = new Date();
    
    if (isNaN(fechaCompraDate.getTime())) return "Sin Garantía";
    
    const diferenciaEnMs = fechaActual.getTime() - fechaCompraDate.getTime();
    const diferenciaEnAnios = diferenciaEnMs / (1000 * 60 * 60 * 24 * 365.25);
    
    return diferenciaEnAnios > 2 ? "Sin Garantía" : "Con Garantía";
  }

  decodeHTMLEntities(text) {
    if (!text) return text;
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }

  formatearFecha(fechaStr) {
    if (!fechaStr || fechaStr === 'No disponible') return 'No disponible';
    
    try {
      const fecha = new Date(fechaStr);
      if (isNaN(fecha.getTime())) return fechaStr;
      
      return fecha.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return fechaStr;
    }
  }

  getEstadoClase(estado) {
    if (!estado) return 'estado-pendiente';
    
    const estadoLower = String(estado).toLowerCase();
    if (estadoLower.includes('cerrado')) {
      return 'estado-completado';
    } else if (estadoLower.includes('diagnostico') || estadoLower.includes('diagnóstico') || estadoLower.includes('proceso')) {
      return 'estado-pendiente';
    } else if (estadoLower.includes('reparado') || estadoLower.includes('completado') || estadoLower.includes('terminado')) {
      return 'estado-completado';
    } else if (estadoLower.includes('espera') || estadoLower.includes('esperando')) {
      return 'estado-espera';
    } else {
      return 'estado-pendiente';
    }
  }

  // Manejo de imágenes
  async fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (file.type === 'application/pdf') {
          resolve(reader.result);
          return;
        }
        
        const img = new Image();
        img.onload = () => resolve(reader.result);
        img.onerror = () => reject(new Error("No se pudo cargar la imagen"));
        img.src = reader.result;
      };
      reader.onerror = error => reject(error);
    });
  }

  async comprimirImagenSiNecesario(file, maxWidth = 800, maxHeight = 800, quality = 0.5) {
    return new Promise((resolve, reject) => {
      if (file.type === 'application/pdf') {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.replace(/[\r\n]+/g, ''));
        reader.onerror = (error) => reject(error);
        return;
      }
      
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          
          if (width > maxWidth) {
            height = Math.round(height * maxWidth / width);
            width = maxWidth;
          }
          if (height > maxHeight) {
            width = Math.round(width * maxHeight / height);
            height = maxHeight;
          }
          
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, width, height);
          
          try {
            const dataUrl = canvas.toDataURL('image/jpeg', quality);
            resolve(dataUrl.replace(/[\r\n]+/g, ''));
          } catch (error) {
            reject(error);
          }
        };
        img.onerror = (error) => reject(error);
      };
      reader.onerror = (error) => reject(error);
    });
  }

  validarArchivo(file) {
    const formatosAceptados = [
      'image/jpeg', 'image/png', 'image/gif', 
      'image/bmp', 'image/webp', 'application/pdf'
    ];
    
    if (!formatosAceptados.includes(file.type)) {
      alert('Por favor, sube una imagen en formato JPG, PNG, GIF, BMP, WEBP o un archivo PDF.');
      return false;
    }
    
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert('El archivo es demasiado grande. El tamaño máximo permitido es 5MB.');
      return false;
    }
    
    return true;
  }

  // Reset y limpieza
  resetearFormularios() {
    document.getElementById('formulario-reparacion').reset();
    document.getElementById('formulario-datos-cliente').reset();
    
    document.getElementById('formulario-reparacion').classList.add('hidden');
    document.getElementById('formulario-datos-cliente').classList.add('hidden');
    document.getElementById('resultado-consulta').classList.add('hidden');
    
    document.getElementById('consulta-reparacion').value = '';
    
    this.ocultarIndicadorPasos();
    
    this.paso1Data = {};
    this.imagenProductoBase64 = '';
    this.imagenBoletaBase64 = '';
    this.imagenShopifyUrl = '';
    
    document.getElementById('producto-imagen-container').classList.add('hidden');
    document.getElementById('detalles-producto').classList.add('hidden');
    document.getElementById('producto-imagen').src = '';
    document.getElementById('marca-valor').textContent = 'Cargando...';
    document.getElementById('id-prod-valor').textContent = 'Cargando...';
    
    const productoPreviewContainer = document.getElementById('imagen-producto-preview-container');
    if (productoPreviewContainer) productoPreviewContainer.classList.add('hidden');
    
    const boletaPreviewContainer = document.getElementById('imagen-boleta-preview-container');
    if (boletaPreviewContainer) boletaPreviewContainer.classList.add('hidden');
    
    const placeholders = document.querySelectorAll('.imagen-placeholder');
    placeholders.forEach(placeholder => placeholder.remove());
  }

  // Indicadores de pasos
  mostrarIndicadorPasos() {
    const indicadorPasos = document.getElementById('pasos-indicador');
    if (indicadorPasos) {
      indicadorPasos.classList.remove('hidden');
    }
  }

  ocultarIndicadorPasos() {
    const indicadorPasos = document.getElementById('pasos-indicador');
    if (indicadorPasos) {
      indicadorPasos.classList.add('hidden');
    }
  }

  actualizarPasoIndicador(paso) {
    document.querySelectorAll('.paso-item').forEach(item => {
      item.classList.remove('paso-activo');
      item.classList.remove('paso-completado');
    });
    
    document.getElementById('paso-' + paso).classList.add('paso-activo');
    
    for (let i = 1; i < paso; i++) {
      document.getElementById('paso-' + i).classList.add('paso-completado');
    }
  }
}

// Instancia global
window.formularioCore = new FormularioCore();